export const UserGuideUrl = 'https://www.getstoryteller.com/user-guide';
